<template>
  <QuestionPage :title="questionAnswerData.question">
    <QuestionAnswer
      :title="questionAnswerData.answers.A"
      class='lt-fyf-answer-eat-in-basic'
      :onSelect="chooseBasic"
    />

    <QuestionAnswer
      :title="questionAnswerData.answers.B"
      class='lt-fyf-answer-eat-in-medium'
      :onSelect="chooseMedium"
    />

    <QuestionAnswer
      :title="questionAnswerData.answers.C"
      class='lt-fyf-answer-eat-in-top'
      :onSelect="chooseTop"
    />
  </QuestionPage>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'getQuestionAnswerData'
    ]),
    questionAnswerData() {
      return this.getQuestionAnswerData('food')
    }
  },
  methods: {
    ...mapMutations([
      'selectFoodStatus',
    ]),
    ...mapActions([
      'goToItem',
    ]),
    chooseBasic: function () {
      this.selectFoodStatus(1);
      this.goToItem('food');
    },
    chooseMedium: function () {
      this.selectFoodStatus(2);
      this.goToItem('food');
    },
    chooseTop: function () {
      this.selectFoodStatus(3);
      this.goToItem('food');
    }
  },
};
</script>

<style lang='scss'>
.lt-fyf-answer-eat-in-basic {
  background-image: url('../../assets/questions/eatin-minimum.jpg');
}
.lt-fyf-answer-eat-in-medium {
  background-image: url('../../assets/questions/eatin-moderate.jpg');
}
.lt-fyf-answer-eat-in-top {
  background-image: url('../../assets/questions/eatin-comfortable.jpg');
}
</style>